/**
 * Codes de statut HTTP côté frontend
 */
export const HTTP_STATUS = {
  // Succès
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  
  // Erreurs client
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  
  // Erreurs serveur
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504
};

/**
 * Statuts de réservation côté frontend (synchronisé avec backend)
 */
export const RESERVATION_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  EXPIRED: 'expired',
  PAYMENT_FAILED: 'payment_failed'
};

/**
 * Statuts de paiement côté frontend
 */
export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SUCCEEDED: 'succeeded',
  COMPLETED: 'completed',
  PARTIAL: 'partial',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  PARTIALLY_REFUNDED: 'partially_refunded',
  NO_REFUND_NEEDED: 'no_refund_needed'
};

/**
 * Types de paiement côté frontend
 */
export const PAYMENT_TYPES = {
  RENTAL: 'rental',
  COMMISSION: 'commission',
  DEPOSIT: 'deposit',
  TAX: 'tax',
  REFUND: 'refund',
  DEPOSIT_REFUND: 'deposit_refund'
};

/**
 * Étapes du processus de réservation
 */
export const BOOKING_STEPS = {
  DETAILS: 'details',
  PAYMENT: 'payment',
  CONFIRMATION: 'confirmation'
};

/**
 * Types d'erreur pour l'interface utilisateur
 */
export const ERROR_TYPES = {
  NETWORK: 'network',
  VALIDATION: 'validation',
  AUTHENTICATION: 'authentication',
  PAYMENT: 'payment',
  SERVER: 'server'
};

/**
 * Messages d'erreur par défaut côté frontend
 */
export const DEFAULT_ERROR_MESSAGES = {
  NETWORK_ERROR: 'Erreur de réseau. Veuillez vérifier votre connexion.',
  SERVER_ERROR: 'Erreur du serveur. Veuillez réessayer plus tard.',
  PAYMENT_FAILED: 'Le paiement a échoué. Veuillez réessayer.',
  VALIDATION_ERROR: 'Veuillez vérifier les informations saisies.',
  UNAUTHORIZED: 'Vous devez être connecté pour effectuer cette action.',
  FORBIDDEN: 'Vous n\'avez pas les permissions nécessaires.',
  NOT_FOUND: 'La ressource demandée n\'a pas été trouvée.',
  TIMEOUT: 'La requête a expiré. Veuillez réessayer.'
};

/**
 * Messages de succès par défaut côté frontend
 */
export const DEFAULT_SUCCESS_MESSAGES = {
  PAYMENT_SUCCESS: 'Paiement effectué avec succès !',
  BOOKING_CONFIRMED: 'Votre réservation a été confirmée !',
  PROFILE_UPDATED: 'Votre profil a été mis à jour.',
  EMAIL_SENT: 'Email envoyé avec succès.',
  CHANGES_SAVED: 'Modifications sauvegardées.'
};
